// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1iG9-","left":"styles_left__3m8oC"};